export default __webpack_public_path__ + "static/media/setting_new.d8bc4962.svg";